import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    color: 'black',
    borderLeft: ' 6px solid lightgray',
    margin: '4px',
    borderRadius: 6,
    padding: '0.25rem 0px',

    '& p': {
      margin: '0 0.5rem'
    }
  }
}))

export default useStyles
